import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Container } from '@mui/material';

import Header from './components/Header';
import PrivateRoute from './components/PrivateRoute';
import LoginScreen from './screens/LoginScreen';
import HomeScreen from './screens/HomeScreen';
import AvailableShiftsScreen from './screens/AvailableShiftsScreen';
import MyShiftsScreen from './screens/MyShiftsScreen';

const App = () => (
  <>
    <Header />
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Routes>
        <Route path="/login" element={<LoginScreen />} />

        <Route element={<PrivateRoute />}>
          <Route path="/" element={<HomeScreen />} />
          <Route path="/shifts/available" element={<AvailableShiftsScreen />} />
          <Route path="/shifts/mine" element={<MyShiftsScreen />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Container>
  </>
);

export default App;
